import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';
const BackIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '30', viewBox = '0 0 30 30' }) => (
    <svg
      id='back_icon'
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <circle id='Ellipse_180' data-name='Ellipse 180' cx='15' cy='15' r='15' fill={fill} />
      <path
        id='arrow-left-short_1_'
        data-name='arrow-left-short (1)'
        d='M19,11.062a.937.937,0,0,1-.937.937H7.2l4.025,4.023A.939.939,0,1,1,9.9,17.35L4.275,11.726a.937.937,0,0,1,0-1.327L9.9,4.774A.939.939,0,1,1,11.226,6.1L7.2,10.125H18.062A.937.937,0,0,1,19,11.062Z'
        transform='translate(3.501 3.751)'
        fill={'#fff'}
      />
    </svg>
  )
);
BackIcon.displayName = 'BackIcon';

export default BackIcon;
